import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {ShippingAddressState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class ShippingAddressQuery extends QueryEntity<ShippingAddressState> {

  constructor(protected store: Store) {
    super(store);
  }

}
